import React, { createContext } from 'react'
import { initialState } from './AppointmentPurchaseType'

export const AppointmentContext = createContext(initialState)
export const AppointmentProvider = AppointmentContext.Provider
